import React from "react";
import Pix from "../../components/doacoes/Pix";
import NavBar from "../../components/navBar";

function PagePix() {
  return (
    <>
      <NavBar />
      <Pix />
    </>
  );
}

export default PagePix;
